export default {
  title: 'Ofertas exclusivas',
  header: {
    back: 'Volver',
    title: 'Recompensas',
  },
  info: {
    title: 'Tienes {{points}} puntos.',
    description: '¡Gasta {{amount}} y obtén 5 puntos! Añade artículos a tu carrito gratis con tus puntos acumulados.',
  },
  rewards: {
    data: [
      {
        title: 'Gana puntos con cada pedido',
        description: 'Cada {{amount}} que gastes suma 5 puntos a tu cuenta.',
      },
      {
        title: 'Gana puntos con cada pedido',
        description:
          '¡Canjea tus puntos por artículos gratis! Empieza a ganar recompensas desde 350 puntos, equivalente a gastar {{amount}}.',
      },
      {
        title: 'Gana puntos con cada pedido',
        description:
          'Descubre ofertas exclusivas, promociones y descuentos. Consulta las promociones solo para miembros en la app.',
      },
    ],
  },
};
